module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAABEklEQVQ4jWOgFDCi61/s6yvAJy29n1NIyABd7sPDhxd+fvrkGLt58wes9oI07ygrO//zy5f/2MC7e/f+r4qOPg9SR7JmGMBqCCHNp2fPxmkIE9SMAoPYWAM2bm4UV/36+pVha34+w41Nm1DEBRUVGSxyckBhZMCCKxJeXrnCcLC1FWwINsDGwwMWxWrAvb17GY5NnIjLbBTAhE2QW1ycAd07JBkgrqPD4NrWBvYr0Qb8+vIFRQKkGWSIrIUFVo0w9cwgIkhd/cKLixc9pAwNJTgFBeGKmNnYGBRsbSGu0tWFi7+/f5/hUGfnhb8/f3bCBUFxCopbUByTnJCINQSbZqyZiZ2Pb7+AvDzpmYlkwMDAAADTVBKD54NvuAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/objectIcons/cabinet_t1.png
// module id = dg9F
// module chunks = 0